import {
	TEMP_WHITE_LIST,
} from "@bracket/whitelist";

export const COUNTRY_BLACK_LIST = [
	"US",
	"CA",
	"IR",
	"KP",
	"CU",
	"SY",
	"MM",
	"RU",
];

export const WHITE_ACCTS = Object.keys(TEMP_WHITE_LIST);
export const API_URL = "https://api.bracket.fi";

export const NAV_PRECISION = 6;

export const STABLE_COIN_SYMBOLS = ["USDC", "USDT"];

export const PROD_ENV = globalThis.location.hostname.startsWith("app") ? "PRODUCTION" : "DEVELOPMENT";
